import { render, staticRenderFns } from "./BindCardSuccess.vue?vue&type=template&id=89c20c5c&scoped=true"
import script from "./BindCardSuccess.vue?vue&type=script&lang=js"
export * from "./BindCardSuccess.vue?vue&type=script&lang=js"
import style0 from "./BindCardSuccess.vue?vue&type=style&index=0&id=89c20c5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c20c5c",
  null
  
)

export default component.exports